/**
 * Every kind, for tests that must cover the whole space rather than the statuses
 * someone happened to think of.
 *
 * Built from a `Record<ErrorKind, true>` rather than written as an array: an
 * `ErrorKind[]` would accept any SUBSET, so omitting a member would compile
 * silently — and a kind missing from here is skipped by every assertion in
 * `getErrorMessageId.test.ts`, which is exactly the drift this file exists to
 * stop. The Record makes a missing member a compile error.
 */
var EVERY_KIND = {
    network: true,
    validation: true,
    unauthenticated: true,
    forbidden: true,
    notFound: true,
    conflict: true,
    unprocessable: true,
    server: true,
    unknown: true,
};
export var ALL_ERROR_KINDS = Object.keys(EVERY_KIND);
/**
 * Guards the exhaustiveness of a `switch` over {@link ErrorKind}. A new member
 * reaches each formatter's `default:` branch as a type error until that
 * formatter answers for it.
 */
export var assertNever = function (kind) {
    throw new Error("Unhandled error kind: ".concat(String(kind)));
};
export var getErrorKind = function (info) {
    var status = info.status;
    // `getErrorInfo` returns `{}` when the thrown value carries no response,
    // which is how a network/abort failure reaches us.
    if (status === undefined)
        return "network";
    if (status === 400)
        return "validation";
    if (status === 401)
        return "unauthenticated";
    if (status === 403)
        return "forbidden";
    if (status === 404)
        return "notFound";
    if (status === 409)
        return "conflict";
    if (status === 422)
        return "unprocessable";
    if (status >= 500)
        return "server";
    return "unknown";
};
